import Swiper, {Navigation} from 'swiper';
import Form from '../../components/form';
import {Utils} from '../../common/scripts/utils';

let slider = {};
const subscribeForm = document.querySelector('.j-form-subscribe');
const newsSlider = document.querySelector('.j-news-section-slider');

if (subscribeForm) {
    const initSubscribeForm = new Form();

    initSubscribeForm.init({
        target        : subscribeForm,
        successMessage: true
    });
}

if (newsSlider) {
    const newsSliderInit = (options) => {
        if (Utils.getWindowWidth() >= 670 && !slider.initialized) {
            slider = new Swiper(newsSlider, options);
            slider.init();
        } else if (Utils.getWindowWidth() < 670 && slider.initialized) {
            slider.destroy();
        }
    };

    const options = {
        init             : false,
        modules          : [Navigation],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 0,
        navigation       : {
            nextEl: '.j-news-section-next',
            prevEl: '.j-news-section-prev'
        },
        breakpoints: {
            1280: {
                allowTouchMove: false
            }
        }
    };

    newsSliderInit(options);

    window.addEventListener('resize', () => {
        newsSliderInit(options);
    });
}
